/**
 * Critical Font Loader
 * ====================
 * Handles font loading to prevent FOIT/FOUT
 */

// Check if fonts are cached
if ('fonts' in document) {
    // Add class when fonts are ready
    document.fonts.ready.then(() => {
        document.documentElement.classList.add('fonts-loaded');
    });
}

// Fallback: add class after timeout if fonts API not supported
if (!('fonts' in document)) {
    setTimeout(() => {
        document.documentElement.classList.add('fonts-loaded');
    }, 3000);
}
